export default __webpack_public_path__ + "static/media/instructor2.f667a08c.jpg";